import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import ContentBoxWithoutHeader from '../../../layout/component/ContentBoxWithoutHeader'
import { BACKEND_URL } from '../../../../util/api'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import VipIcon from '../../../form/component/VipIcon'
import RushIcon from '../../../form/component/RushIcon'
import ToggleButton from '../../../form/component/ToggleButton'
import DatePicker from '../../../form/component/DatePicker'
import {
    renderEventName,
    renderProcessName,
    renderRoleName,
    renderStateName,
    renderTaskName,
} from '../../util/names'

import BeamProcessInstance from './BeamProcessInstance'
import ContentBoxHeader from '../../../layout/component/ContentBoxHeader'
import ContentBoxBody from '../../../layout/component/ContentBoxBody'
import ValidationMessageList from '../../../validation/component/ValidationMessageList'
import currentUserHasAccess from '../../../../util/widget-helper'
import { PROCESS_OVERVIEW } from '../../ui-definition/process-ui'

const PROCESS_FLOW_URL =
    BACKEND_URL + '/process/instance/view-flow?processInstanceId='

const FRAME_STYLE = {
    border: 0,
    width: '100%',
    height: '600px',
}

const ToggleProcessFlowButton = ({
    toggleProcessFlowVisibility,
    processFlowVisible,
}) => {
    return (
        <span>
            <ToggleButton
                toggle={toggleProcessFlowVisibility}
                active={processFlowVisible}
                activeIcon="fa fa-search-minus"
                inactiveIcon="fa fa-search-plus"
            />
            &#160;
        </span>
    )
}

const TransitionList = ({
    openTask,
    availableTransitionList,
    validateAndTriggerEvent,
    processInstance,
}) => {
    if (openTask) {
        return null
    }
    return (
        <span>
            {availableTransitionList.map(transition => {
                const { eventName, technicalEvent, hide } = transition
                if (technicalEvent || hide) {
                    return null
                }
                return (
                    <span key={eventName}>
                        <button
                            onClick={() => {
                                validateAndTriggerEvent(
                                    processInstance.id,
                                    processInstance.currentStateName,
                                    eventName
                                )
                            }}
                            className="btn-primary btn btn-sm"
                        >
                            {renderEventName(eventName)}
                        </button>
                        &#160;
                    </span>
                )
            })}
        </span>
    )
}

const ProcessFlow = ({ processFlowVisible, processInstanceId }) => {
    if (!processFlowVisible) {
        return null
    }
    return (
        <Row>
            <Column size={12}>
                <iframe
                    style={FRAME_STYLE}
                    src={PROCESS_FLOW_URL + processInstanceId}
                    title="Process Flow"
                />
            </Column>
        </Row>
    )
}

const Overview = ({
    openTask,
    toggleVIPStatus,
    toggleRushStatus,
    changeTime,
    processInstance,
    validateAndTriggerEvent,
    processFlowVisible,
    availableStateList,
    toggleProcessFlowVisibility,
    availableTransitionList,
    changeBeamProcessState,
    beamProcessState,
    beamProcessInstance,
    validationMessageList,
    isProductionAdmin,
}) => {
    if (!currentUserHasAccess(PROCESS_OVERVIEW)) {
        return null
    }

    return (
        <ContentBoxWithoutHeader>
            <ContentBoxHeader>
                <h1>
                    <VipIcon
                        onClick={() => {
                            toggleVIPStatus()
                        }}
                        active={processInstance.vip}
                    />
                    &#160;
                    <RushIcon
                        onClick={() => {
                            if (isProductionAdmin) {
                                toggleRushStatus()
                            }
                        }}
                        active={processInstance.rush}
                    />
                    &#160;
                    {'Process ' +
                        renderProcessName(processInstance.processName) +
                        ' ' +
                        processInstance.displayName}
                    &#160;
                </h1>
            </ContentBoxHeader>

            <ContentBoxBody>
                <Row>
                    <Column size={8}>
                        <ToggleProcessFlowButton
                            toggleProcessFlowVisibility={
                                toggleProcessFlowVisibility
                            }
                            processFlowVisible={processFlowVisible}
                        />
                        <TransitionList
                            openTask={openTask}
                            processInstance={processInstance}
                            availableTransitionList={availableTransitionList}
                            validateAndTriggerEvent={validateAndTriggerEvent}
                        />
                    </Column>
                    <Column size={4} className="align-right">
                        <BeamProcessInstance
                            availableStateList={availableStateList}
                            changeBeamProcessState={changeBeamProcessState}
                            beamProcessState={beamProcessState}
                            beamProcessInstance={beamProcessInstance}
                        />
                    </Column>
                </Row>
                <Row>
                    <Column size={12}>
                        <ValidationMessageList
                            validationMessageList={validationMessageList}
                        />
                    </Column>
                </Row>
                <ProcessFlow
                    processFlowVisible={processFlowVisible}
                    processInstanceId={processInstance.id}
                />

                <Row top="M">
                    <Column size={12}>
                        <table className="process-info-table">
                            <tbody>
                                <tr>
                                    <td>Task</td>
                                    <td>
                                        {openTask && (
                                            <Link
                                                to={
                                                    '/task/detail/' +
                                                    openTask.id
                                                }
                                            >
                                                {renderTaskName(openTask.name)}
                                            </Link>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Responsible</td>
                                    <td>
                                        {openTask &&
                                            renderRoleName(openTask.role)}
                                    </td>
                                </tr>
                                <tr>
                                    <td>State</td>
                                    <td>
                                        {renderStateName(
                                            processInstance.currentStateName
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Wakeup</td>
                                    <td>
                                        {!processInstance.emailActionWakeup &&
                                            !processInstance.timeoutWakeup &&
                                            'none'}
                                        {processInstance.emailActionWakeup && (
                                            <DatePicker
                                                object={processInstance}
                                                name="emailActionWakeup"
                                                showTimeSelect={true}
                                                dateFormat="DD.MM.YYYY HH:mm"
                                                placeholder="Next Activity"
                                                onChange={changeTime}
                                                onBlur={() => {}}
                                            />
                                        )}
                                        {processInstance.timeoutWakeup && (
                                            <DatePicker
                                                object={processInstance}
                                                name="timeoutWakeup"
                                                showTimeSelect={true}
                                                dateFormat="DD.MM.YYYY HH:mm"
                                                placeholder="Next Activity"
                                                onChange={changeTime}
                                                onBlur={() => {}}
                                            />
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Column>
                </Row>
            </ContentBoxBody>
        </ContentBoxWithoutHeader>
    )
}

Overview.propTypes = {
    processInstance: PropTypes.object,
    processFlowVisible: PropTypes.bool.isRequired,
    validateAndTriggerEvent: PropTypes.func.isRequired,
    eventList: PropTypes.array,
}

export default Overview



// WEBPACK FOOTER //
// ./src/modules/process/component/instance-detail/Overview.js